import React, { Component } from 'react'
import "../css/OlvidoContrasenia.css";
import equis from "../assets/eliminar.svg"
import check from '../assets/check.svg';
import info from "../assets/Info.png";
import phoneIcon from "../assets/Phone.svg";
import emailIcon from "../assets/Mail.svg";
import Modal from '././components/Modal';
import axios from 'axios';
import Header from '../pages/components/Header.js'
import Footer from '../pages/components/Footer.js'
import CenteredWrapper from '../pages/components/CenteredWrapper.js'
import { Navigate } from 'react-router-dom';
import checkGreen from "../assets/check.png";

export class OlvidoContrasenia extends Component {

    constructor(props) {
        super(props);

        this.state = {
            verFormOlvidoContra: false,
            verModalOlvidoContra: false,
            modalCheck: false,
            loading: false,
            activebutton: true,
            usuarioExt: false,
            datosUsuario: {
                identificacion: "",
                correoIngresado: "",

            },
            modalMessage: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: ""
            },

            getDatos: {
                id: 0,
                nombres: "",
                apellidos: "",
                correoAlterno: "",

            },
            modal: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: ""
            },
            correoOculto: "",
            expresiones: {
                /*cedula:/^[\d]{10}$/,*/
              cedula: /^[a-zA-Z0-9._]{4,10}$/,
              correo: /^(\w+[/./-]?){1,}@[a-z]+([/.]\w+)+$/,

              //correo: /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}([/.]\w{2,})?$/,

            },
            errorDatosUsuario: {
            },
            errorCorreoIngresado: {
            },
            renderNavigateLogin: false,
        };

        //this.renderFormOlvidoContra=this.renderFormOlvidoContra.bind(this);

        this.abrirModal = this.abrirModal.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);

        this.abrirModalError = this.abrirModalError.bind(this);
        this.cerrarModalError = this.cerrarModalError.bind(this);

        this.abrirModalOlvidoContra = this.abrirModalOlvidoContra.bind(this);
        this.cerrarModalOlvidoContra = this.cerrarModalOlvidoContra.bind(this);

        this.abrirModaCheck = this.abrirModaCheck.bind(this);
        this.cerrarModalCheck = this.cerrarModalCheck.bind(this);

        this.setonloading = this.setonloading.bind(this);
        this.setoffloading = this.setoffloading.bind(this);

    }

    setonloading() {
        this.setState({ loading: true });
    }


    setoffloading() {
        this.setState({ loading: false });
    }

    abrirModalError() {
        this.setState({
            modalMessage: {
                ...this.state.modalMessage,
                show: true
            }
        });
    }

    cerrarModalError() {
        this.setState({
            modalMessage: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
        //console.log("cerrar modal " + this.state.modalMessage);
    }


    abrirModaCheck() {
        this.setState({ modalCheck: true });
    }

    cerrarModalCheck() {
        this.setState({ modalCheck: false });
        this.setState({ renderNavigateLogin: true })
    }

    abrirModalOlvidoContra() {
        this.setState({ verModalOlvidoContra: true });

    }

    cerrarModalOlvidoContra() {
        this.props.callTagManager("click-btn-cancelar-sol-olvido-contrasena");
        this.setState({ verModalOlvidoContra: false });

    }

    abrirModal() {
        this.setState({
            modal: {
                ...this.state.modal,
                show: true
            }
        });
    }

    cerrarModal() {
        this.setState({
            modal: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
        //console.log("cerrar modal "+this.state.modal);
    }

    postEnviarCorreo = async () => {
        const { usuarioExt } = this.state;

        this.props.callTagManager("click-btn-enviar-sol-olvido-contrasena");
        this.setonloading();
        this.setState({ activebutton: false });

        if (usuarioExt){
            var datos = {
                email: this.state.datosUsuario.correoIngresado,
                personaId: this.state.getDatos.id
            }
            try{
                const resp = await axios.post(`${process.env.REACT_APP_API_EXT}/Account/ResetearContrasenia`, datos);

                if (resp.data?.status?.isSuccessfully){
                    this.abrirModaCheck();
                }else{
                    //console.log("Error de respuesta no exitosa en ResetearContrasenia");

                    this.setState({
                        modalMessage: {
                            show: true,
                            titulo: "Error",
                            mensaje: "Lo sentimos, tuvimos un problema.",
                            imagen: equis,
                        }
                    });
                }
            }
            catch (error) {
                //console.log("Error del Catch Resetear Contraseña" + error);
                
                this.setState({
                modal: {
                    show: true,
                    titulo: "Error",
                    mensaje: "Lo sentimos, ha ocurrido un error.",
                    imagen: equis,
                }
                });
            }

            this.setoffloading();
            this.setState({ activebutton: true });
            

        }else{
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token => {
                    var datos = {
                        personaId: this.state.getDatos.id,
                        correo: this.state.datosUsuario.correoIngresado,
                    }
                    axios.post(`${process.env.REACT_APP_API}api/CuentaUsuario/verificaremail`, datos,{
                        headers: {
                        'X-Recaptcha-Token': token
                        }
                    })
                    .then(resp => {
                        if (resp.status === 200) {
                            this.abrirModaCheck();
                            //console.log("pots enviar correo");
                        }

                    }).catch(error => {
                        this.setState({
                            modalMessage: {
                                show: true,
                                titulo: "Error en la solicitud",
                                mensaje: error.response.data.errorMessage,
                                imagen: equis
                            }
                        })
                    })
                    this.setoffloading();
                    this.setState({ activebutton: true });
                });
            });
        }

        /*var datos = {
            personaId: this.state.getDatos.id,
            correo: this.state.datosUsuario.correoIngresado
        }*/        
    }

    componentWillMount() {
        this.useEffect();
    }

    useEffect = () => {
        const loadScriptByURL = (id, url, callback) => {
            const isScriptExist = document.getElementById(id);

            if (!isScriptExist) {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = url;
                script.id = id;
                script.onload = function () {
                    if (callback) callback();
                };
                document.body.appendChild(script);
            }

            if (isScriptExist && callback) callback();
        }
        loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_CAPTCHAKEY}`, function () {
    });
    };

    postOlvidoContraApiExt = async (data) => {
        window.grecaptcha.ready(()=>{
            window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token =>{
                const config = {
                    headers: {
                        'X-Recaptcha-Token': token
                    }
                };

                axios.post(`${process.env.REACT_APP_API_EXT}/Account/OlvidoContrasenia`, data, config)
                .then((response) =>{
                    if (response.data?.status?.isSuccessfully){
                        this.setState({
                            getDatos: {
                            id: response.data.data.personaId,
                            nombres: response.data.data.nombres,
                            apellidos: response.data.data.apellidos,
                            correoAlterno: response.data.data.email,
                            },
                            usuarioExt: true,
                            verModalOlvidoContra: true
                        });
                    } else{
                        this.setState({
                            modal: {
                                show: true,
                                titulo: "Error",
                                mensaje: response.data.status.messages[0],
                                imagen: equis,
                            }
                        });
                    }
                })
                .catch((error) => {
                    this.setState({
                        modal: {
                            show: true,
                            titulo: "Error",
                            mensaje: "Ocurrió un error en el servidor.",
                            imagen: equis,
                        }
                    });
                });
            });
        });
    };


    renderFormOlvidoContra = async (e) => {
        this.props.callTagManager("click-btn-verificar-olvido-contrasena");
        this.setonloading();
        this.setState({ activebutton: false });

        e.preventDefault();

        var olvidarContrasenia = {
            identificacion: this.state.datosUsuario.identificacion,
        }

        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token => {
            axios.post(`${process.env.REACT_APP_API}api/Persona/cuenta`, olvidarContrasenia,{
                      headers: {
                        'X-Recaptcha-Token': token
                      }
                    })
                    .then(async (resp) => {
                        if (resp.data.success) {
                            let correoAlterno_temp = resp.data.persona.correoalterno;
                            if (correoAlterno_temp === "0" || correoAlterno_temp === "") {
                                this.setState({
                                    modal: {
                                        show: true,
                                        titulo: "Error en la solicitud",
                                        mensaje: <span className='olvContra-mdl-text' align="justify">En caso de NO tener actualizado el correo alterno o los datos presentados son incorrectos, puede comunicarse de lunes a viernes de 8h00 a 16h00 al teléfono (+593) 42269256 o escribir al siguiente correo:
                                            <a href="mailto:gerenciatecnologia@espol.edu.ec?" ><i>gerenciatecnologia@espol.edu.ec</i></a>
                                        </span>,
                                        imagen: equis
                                    }
                                });
                            } else {
                                this.setState({
                                    getDatos: {
                                        id: resp.data.persona.idsccepersona,
                                        nombres: resp.data.persona.nombres,
                                        apellidos: resp.data.persona.apellidos,
                                        correoAlterno: resp.data.persona.correoalterno,
                                    }
                                });
                                //this.ocultarCorreo();
                                this.setState({ verModalOlvidoContra: true });


                            }
                        } 
                        // else {
                        //     //console.log("no entra");
                        //     await this.postOlvidoContraApiExt(olvidarContrasenia);
                        // }
                        //console.log("fuera");
                        this.setoffloading();
                        this.setState({ activebutton: true });


                    }).catch(async (error) => {
                        let messageError = error.response.data.errorMessage;
                        //console.log(messageError);

                        if (typeof messageError === 'string' && messageError !== null) {
                            // if (messageError.includes("No se encontro persona con esa cedula")) {
                            //     await this.postOlvidoContraApiExt(olvidarContrasenia);
                            // } else {
                            //     this.setState({
                            //         modal: {
                            //         show: true,
                            //         titulo: "Error en la solicitud",
                            //         mensaje: messageError,
                            //         imagen: equis,
                            //         }
                            //     });
                            // }
                            this.setState({
                                modal: {
                                show: true,
                                titulo: "Error en la solicitud",
                                mensaje: messageError,
                                imagen: equis,
                                }
                            });
                        }                        
                        this.setoffloading();
                        this.setState({ activebutton: true });
                    });
            });
        });
    }

    ocultarCorreo() {
        var correo = this.state.getDatos.correoAlterno;
        var username = correo.split("@")[0];
        var dominiocomp = correo.split("@")[1];
        var dominio_nomb = dominiocomp.split(".")[0];
        //var dominio_ext = dominiocomp.split(".")[1];
        var tamano_username = username.length;
        var asteriscos = "*".repeat(tamano_username - 3)
        //var tamano_dominio_nomb = dominio_nomb.length;
        //var tamano_dominio_nombult = dominio_nomb.length-1;
        //var asteriscos_dominio = "*".repeat(tamano_dominio_nomb - 2)
        //console.log(`${username.substring(0,3)}${asteriscos}`);
        var correoOculto = `${username.substring(0, 3)}${asteriscos}@${dominiocomp}`;
        //var correoOculto = `${username.substring(0, 3)}${asteriscos}@${tamano_dominio_nomb.substring(0, 1)}${asteriscos_dominio}${tamano_dominio_nomb.substring({ tamano_dominio_nombult })}.${dominio_ext}`;
        this.setState({ correoOculto: correoOculto })
    }

    handlerDatos = async (e) => {
        await this.setState({
            datosUsuario: {
                ...this.state.datosUsuario,
            [e.target.name]: e.target.value.toLowerCase(),
            }
        })
        //console.log(this.state.datosUsuario);

        this.handlerOnBlur();
        this.handleCorreIngresado();
    }


    handleCorreIngresado = async () => {
        //console.log(this.state.datosUsuario.correoIngresado);
        //console.log(this.state.getDatos.correoAlterno);
      //console.log(this.state.datosUsuario.correoIngresado+" : " + this.state.expresiones.correo.test(this.state.datosUsuario.correoIngresado));
      //if (this.state.datosUsuario.correoIngresado != this.state.getDatos.correoAlterno) {
      if (!this.state.expresiones.correo.test(this.state.datosUsuario.correoIngresado)) {
        
            await this.setState({
              errorCorreoIngresado: {
                  ...this.state.errorCorreoIngresado,
                  correoIngresado: "Debe ingresar un email valido"
                 // correoIngresado: "El correo debe coincidir con el correo oculto"
              }
            }, ()=>{
             //console.log(this.state.datosUsuario.correoIngresado)
            })
        } else {
            this.setState({
                errorCorreoIngresado: {
                    ...this.state.errorCorreoIngresado,
                    correoIngresado: ""
                }
            })
        }
    }

    handlerOnBlur = async () => {

        if (!this.state.expresiones.cedula.test(this.state.datosUsuario.identificacion)) {
            await this.setState({
                errorDatosUsuario: {
                    ...this.state.errorDatosUsuario,
                    identificacion: "Identificacion debe tener al menos 4 caracteres"
                }
            })
        } else {
            this.setState({
                errorDatosUsuario: {
                    ...this.state.errorDatosUsuario,
                    identificacion: ""
                }
            })
        }
    }

    render() {
        
        return (
            this.state.renderNavigateLogin ? <Navigate to="/Inicio" /> :


                <div >
                    <Header />
                    <CenteredWrapper>
                        <div className="olvContra-container" >
                            <div className="olvContra-container-btn" >
                                <div className="col-xl-4">

                                </div>
                                <div className="col-12 col-lg-8 col-xl-4 title_olvido_contra">
                                    <p className="olvContra-title"><b>OLVIDÓ SU CONTRASEÑA</b></p>
                                </div>
                                <div className="col-xl-4">
                                </div>
                            </div>
                            <div className="olvContra-container-btn">
                                <div className="col-xl-4">

                                </div>
                                <div className="col-10 col-lg-8 col-xl-4">
                                    <div className="row">
                                        <label 
                                            htmlFor="identificacion" 
                                            className="form-label text-start w-100"
                                            style={{ color: "rgb(80, 110, 163)" }}
                                        >
                                            Número de Identificación:
                                        </label>
                                        <input
                                            className={this.state.errorDatosUsuario.identificacion ? "form-control olvidoContra-input-error" : "form-control"}
                                            id="identificacion"
                                            placeholder="Número de doc. de Identidad"
                                            name="identificacion"
                                            value={this.state.datosUsuario.identificacion}
                                            onChange={this.handlerDatos}
                                            onBlur={this.handlerOnBlur} />

                                        {this.state.errorDatosUsuario.identificacion &&
                                            <p className='olvidoContra-leyenda'>{this.state.errorDatosUsuario.identificacion}</p>
                                        }
                                    </div>



                                    <div className="row mt-4" align="center">
                                        <div className="col-xl-12" >
                                            <button
                                                type="submit"
                                                disabled={this.state.datosUsuario.identificacion &&
                                                    !this.state.errorDatosUsuario.identificacion && this.state.activebutton ? false : true}
                                                className={this.state.datosUsuario.identificacion &&
                                                    !this.state.errorDatosUsuario.identificacion && this.state.activebutton ?
                                                    "btn-verificar-olvidoContra" : "btn-verificar-olvidoContra-disabled"}
                                                onClick={this.renderFormOlvidoContra}>
                                                SEGUIR
                                            </button>
                                            {!this.state.activebutton ?
                                                <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                                : null}
                                        </div>

                                    </div>

                                </div>

                                <div className="col-xl-4">
                                </div>
                            </div>
                        </div>
                    </CenteredWrapper>
                    <Footer />
                    {this.state.verModalOlvidoContra &&
                        <Modal isOpen={this.state.verModalOlvidoContra} cerrarModal={this.cerrarModalOlvidoContra} verBoton={false} textoBoton="ACEPTAR" >
                            <p className='olvContra-mdl-text text-center'>Hola <strong>{this.state.getDatos.nombres} {this.state.getDatos.apellidos}</strong></p>
                            <p className='olvContra-mdl-text' align="justify"> En caso de no tener actualizado el correo alterno o los datos presentados son incorrectos, puede comunicarse:</p>
                            <div className="olvContra-mdl-contacto">
                                <div className="contacto-item">
                                    <img src={phoneIcon} alt="Teléfono" className="icono-contacto"/>
                                    <span><strong>(+593) 422699256</strong></span>
                                </div>
                                <div className="contacto-item">
                                    <img src={emailIcon} alt="Correo" className="icono-contacto"/>
                                    <span><a href="mailto:gerenciatecnologia@espol.edu.ec"><i>gerenciatecnologia@espol.edu.ec</i></a></span>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xl-1">

                                </div>
                                <div align="center" className="col-xl-10">
                               <label htmlFor="identificacion" className="olvContra-mdl-corrOcul form-label">Su correo alterno verificado es:<b> {this.state.getDatos.correoAlterno}</b></label>

                                    <input
                                        className={this.state.errorCorreoIngresado.correoIngresado ? "form-control registro-input-error" : "form-control"}
                                        id="correoIngresado"
                                        placeholder="Ingrese su correo"
                                        name="correoIngresado"
                                        value={this.state.correoIngresado}
                                        onChange={this.handlerDatos}
                                        onBlur={this.handleCorreIngresado}
                                    />
                                    {this.state.errorCorreoIngresado.correoIngresado &&
                                        <p className='olvidoContra-leyenda'>{this.state.errorCorreoIngresado.correoIngresado}</p>
                                    }

                                    <p className="olvContra-mdl-pie">Verificar su nueva contraseña en su correo electrónico para culminar el proceso</p>
                                </div>




                            </div>

                            <div className="row">
                                <div className="col-xl-3">
                                </div>

                                <div align="center" className="col-12 col-xl-3 mb-1">
                                    <button onClick={this.cerrarModalOlvidoContra} disabled={this.state.activebutton ? false : true}
                                        className="olvContra-mdl-btn-cancelar">                                              
                                        <div className="">
                                            CANCELAR
                                        </div>
                                        <div className="">
                                            <img className="olvContra-logo" src={equis} alt="No aceptar" />
                                        </div>                       
                                    </button>
                                </div>

                                <div align="center" className="col-12 col-xl-3 mb-1">
                                    <button onClick={this.postEnviarCorreo}
                                        disabled={this.state.datosUsuario.correoIngresado &&
                                            !this.state.errorCorreoIngresado.correoIngresado && this.state.activebutton ? false : true}
                                        className={this.state.datosUsuario.correoIngresado &&
                                            !this.state.errorCorreoIngresado.correoIngresado && this.state.activebutton ? "olvContra-mdl-btn" : "olvContra-mdl-btndsb"}>
                                        <div className="">
                                            ENVIAR
                                        </div>
                                        <div className="">
                                            <img className="olvContra-logo" src={check} alt="Aceptar" />
                                        </div>
                                    </button>
                                </div>

                                
                                {!this.state.activebutton ?
                                    <div className="col-12 col-xl-1 text-center mt-2">

                                        <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                    </div>
                                    : null}



                            </div>



                        </Modal>}
                    {this.state.modal.show &&
                        <Modal isOpen={this.state.modal.show} cerrarModal={this.cerrarModal} verBoton={true} textoBoton="ACEPTAR" >
                            <p className='text-center'><strong>{this.state.modal.titulo}</strong></p>
                            <div className='mt-3 mb-3' align="center">
                                <img className="olvidoContra-mdl-img" src={this.state.modal.imagen} alt="Error"></img>
                            </div>

                            <p className='text-center'>{this.state.modal.mensaje}</p>


                        </Modal>
                    }
                    {this.state.modalMessage.show &&
                        <Modal isOpen={this.state.modalMessage.show} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                            <p className='text-center'><strong>{this.state.modalMessage.titulo}</strong></p>
                            <div className='mt-3 mb-3' align="center">
                                <img className="registroContra-check" src={this.state.modalMessage.imagen} alt="Exitoso"></img>
                            </div>

                            <p className='text-center'>{this.state.modalMessage.mensaje}</p>
                        </Modal>}


                    {this.state.modalCheck && <Modal isOpen={this.state.modalCheck} cerrarModal={this.cerrarModalCheck} verBoton={true} textoBoton="ACEPTAR" >
                        <p className='text-center'><strong>Formulario enviado</strong></p>
                        <div className='mt-3 mb-3' align="center" >
                            <img className="olvidoContra-mdl-img" src={checkGreen} alt="Exitoso"></img>
                        </div>
                        <br />

                        <p className='text-center'><strong>¡Gracias por finalizar el formulario!</strong></p>
                        <p className='text-center'>Le llegará a su correo alterno mayor información para continuar con el proceso del reinicio de su contraseña.</p>
                    </Modal>
                    }

                </div>
        )
    }
}

export default OlvidoContrasenia
